module.exports = __webpack_public_path__ + "cfea9e094d58b54abf242e795f0b913f.gif";